// extracted by mini-css-extract-plugin
export default {"titleFlexStart":"styles_titleFlexStart__mzv6g"};